import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, FormLabel, TextField, Box, Button } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { changeDatesToUTC } from "../utils/dateUtils";
import * as yup from "yup";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL } from "../consts";
import { Clubs } from "../prismaTypes";
import { useState, useEffect } from "react";
import { queryClient } from "../App";
import { useSnackbar } from "notistack";
import { LoadingButton } from "@mui/lab";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";

const Input = styled("input")({
  display: "none",
});

type Inputs = {
  anticipoAccensioneBottoni: number;
  logo: string | null;
};

const schema = yup
  .object({
    anticipoAccensioneBottoni: yup.number().min(0).required(),
  })
  .required();
export function ImpostazioniClub() {
  const [loaded, setLoaded] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const { isLoading: isLoadingClub, data: club } = useQuery<{ club: Clubs }, AxiosError>(
    ["club/getByDomain", window.location.host],
    () => axios.get(API_URL + "club/getByDomain").then((res) => res.data),
    {
      refetchOnWindowFocus: false,
      onSuccess: (data: { club: Clubs }) => {
        const { club } = data;
        setLoaded(true);

        setValue("anticipoAccensioneBottoni", club.anticipoAccensioneBottoni);
        setValue("logo", club.logo);
      },
    }
  );

  const { mutate: mutateUpdate } = useMutation(
    (data: Inputs) => {
      return axios.post(API_URL + "club/updateClubAdmin", { ...data });
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries();
        enqueueSnackbar("Club Aggiornato", { variant: "success" });
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries();
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  const {
    control,
    reset,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm<Inputs>({
    mode: "all",
    resolver: yupResolver(schema),
  });

  const onSubmit = (data: Inputs) => {
    changeDatesToUTC(data);
    mutateUpdate(data);
  };

  const [animations, setAnimations] = useState(false);
  useEffect(() => {
    let timeout = 0;
    if (loaded) {
      timeout = window.setTimeout(() => setAnimations(true), 1);
    }
    return () => {
      if (timeout !== 0) clearTimeout(timeout);
    };
  }, [loaded]);

  const { isLoading, mutate: uploadLogo } = useMutation(
    (data: any) => {
      return axios.post(API_URL + "club/uploadLogoId", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    {
      onSuccess: (resp: AxiosResponse) => {
        // queryClient.invalidateQueries();
        enqueueSnackbar("Logo caricato", { variant: "success" });
        setValue("logo", resp.data?.file);
      },
      onError: (error: AxiosError) => {
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  const handleLogoUpload = (event: any) => {
    const data = new FormData();
    data.append("file", event.target.files[0]);
    uploadLogo(data);
  };

  return (
    <Box className={animations ? "" : "noAnimation"}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container>
          <Grid item xs={12}>
            <FormLabel component="legend" sx={{ mt: 1 }}>
              Anticipo visualizzazione pulsanti per luci etc
            </FormLabel>
            <Controller
              name="anticipoAccensioneBottoni"
              control={control}
              defaultValue={30}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  variant="standard"
                  label="Minuti"
                  type="number"
                  sx={{ width: 150 }}
                  error={Boolean(errors.anticipoAccensioneBottoni)}
                  helperText={errors.anticipoAccensioneBottoni?.message ?? " "}
                />
              )}
            />
          </Grid>

          {getValues("logo") && (
            <Grid item xs={12}>
              <Box sx={{ mt: 2 }}>
                <img
                  src={API_URL + "/loghi/" + getValues("logo")}
                  crossOrigin="anonymous"
                  alt="logo"
                  width="250px"
                />
              </Box>
            </Grid>
          )}
        </Grid>
        <Button type="submit" variant="contained" sx={{ mt: 2 }}>
          Modifica Club
        </Button>
        <label htmlFor="upload-button-file">
          <Input id="upload-button-file" multiple type="file" onChange={handleLogoUpload} />
          <LoadingButton
            sx={{ mt: 2, ml: 2 }}
            variant="contained"
            color="secondary"
            component="span"
            loading={isLoading}
            startIcon={<CloudUploadIcon />}
          >
            Carica Logo
          </LoadingButton>
        </label>
      </form>
    </Box>
  );
}
